<template>
	<div 
			class="component uploader upload-container"
			:class="{ dragging: dragging }"
			ref="uploadContainer"
			@dragover.prevent
			@dragenter="handleDragEnter"
			@dragleave="handleDragLeave"
			@drop="handleFileDrop"
		>
		<form ref="uploadForm" @submit.prevent="submitForm">
			<input type="hidden" :name="csrfName" :value="csrfToken">
			<input
				type="file"
				ref="fileInput"
				name="files[]"
				accept="image/*,video/*"
				class="file-input"
				@change="handleManualInput"
			/>
			<div
				class="upload-icon"
				@drop="handleFileDrop"
				@click="triggerFileInput"
				v-if="!isUploading && !uploadDone && !filesDropped">
				<span class="material-symbols-outlined xlarge">
					<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M440-320v-326L336-542l-56-58 200-200 200 200-56 58-104-104v326h-80ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>
				</span>
				<p class="uk-padding" v-show="desktop">Klik op het icoon of sleep hier een bestand in om een video of foto te uploaden</p>
				<p class="uk-padding" v-show="!desktop">Klik op het icoon om een video of foto te uploaden</p>
				
			</div>
			<div @drop="handleFileDrop"
				class="uk-width-1-1 uk-padding uk-overflow-hidden" v-show="filesDropped && !isUploading && !uploadDone">
				<p>Bestand selecteerd: <br />{{ droppedFile }}</p>
				<textarea class="uk-textarea" name="description" ref="description" placeholder="Heb je nog informatie die relevant is, vul het hier in... Zo niet, klik op upload!"></textarea>
				<button class="uk-button uk-button-primary uk-margin-top" type="submit">Nee, start upload</button>
				<button class="uk-button uk-button-secondary uk-margin-top uk-margin-small-left" @click.prevent="resetForm">Annuleren</button>
			</div>
		</form>
		<div v-if="isUploading">
			<LoadingIndicator /><br />
			<p v-if="uploadPercentage">{{ uploadPercentage }}%</p>
		</div>
		<p v-if="uploadDone && !uploadError">
			<span class="material-symbols-outlined xlarge"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg></span><br />
			We hebben je inzending ontvangen en zullen er z.s.m. naar kijken.
		</p>
		<p v-if="uploadError" class="uk-alert uk-alert-danger" v-html="uploadError"></p>
	</div>
</template>

<script>
import axios from "axios"; // Assuming you're using axios for HTTP requests
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	components: { LoadingIndicator },
	props: {
		desktop: {
			type: Boolean,
			default: null
		}
	},
	data() {
		return {
			isUploading: false,
			uploadDone: false,
			uploadPercentage: null,
			uploadError: null,
			dragging: false,
			filesDropped: false,
			droppedFile: null
		};
	},
	computed: {
		csrfName () {
				return window.csrfTokenName
		},
		csrfToken () {
				return window.csrfTokenValue
		},
	},		
	methods: {
		triggerFileInput() {
			this.$refs.fileInput.click();
		},
		resetForm(event) {
			
			this.$logger("app/components/uploader/resetForm");
			
			this.uploadDone = false;
			this.filesDropped = false;
			this.isUploading = false;
			this.uploadError = false;
			this.uploadPercentage = null;
			this.dragging = false;
			this.droppedFile = null;
			
			this.$refs.uploadForm.reset();
		},
		submitForm(event) {
			
			var component = this;

			const files = component.$refs.fileInput.files;
			if (!files.length) {
				console.error('no files');
				return;
			}
			
			component.$logger("app/components/uploader/submitForm");
			component.$logger("app/components/uploader/files: " + files.length);
							
			// Create formData object
			var formData = new FormData(event.target);
		
			// Append files
			if(files.length > 1) {
				for (let i = 0; i < files.length; i++) {
					formData.append("files[]", files[i]);
				}
			}			
			
			// Append description
			formData.append("description", component.$refs.description.value);
			
			// Add CSRF
			var data = {};			
			formData.append(data[component.csrfName], component.csrfToken);
			
			// Toggle indicator
			this.isUploading = true;
		
			// Do request
			axios({
				method: 'post',
				url: '/actions/_uploader/upload/upload',
				responseType: 'json',
				data: formData,
				headers: {
					"Content-Type": "multipart/form-data",
					"X-CSRF-Token": component.csrfToken
				},
				onUploadProgress: (progressEvent) => {
					this.uploadPercentage = Math.round(
						(progressEvent.loaded * 100) / progressEvent.total
					);
				}
			})
			.then(function (response) {
				component.isUploading = false;
				component.uploadDone = true;

				component.$logger("app/components/uploader/done");
				
				setTimeout(function() {
					component.resetForm();
				}, 3000);
			})
			.catch(function (error) {

				component.$logger("app/components/uploader/error", "error");
				component.$logger(error, 'error');
				
				component.isUploading = false;			
				component.uploadDone = true;
				component.uploadError = error.response.data.name ?? '';
				
				if(error && error.response && error.response.data && error.response.data.message) {
					component.uploadError += '<br>' + error.response.data.message;
				}
			});
		},
		handleManualInput() {
			this.filesDropped = true;	
			let fileName = this.$refs.fileInput.files[0].name;
				if (fileName.length > 20) {
						this.droppedFile = fileName.slice(0, 14) + '...' + fileName.slice(-6);
				} else {
						this.droppedFile = fileName;
				}
		},
		handleDragEnter(event) {
			this.dragging = true;
		},
		handleDragLeave(event) {
			this.dragging = false;
		},
		handleFileDrop(event) {
			event.preventDefault();
			this.dragging = false;
			const files = event.dataTransfer.files;

			if (files.length) {
				this.filesDropped = true;			
				this.$refs.fileInput.files = files;
				//this.submitForm({ target: this.$refs.fileInput });
			}
		},		
	},
};
</script>

<style scoped>
.component.uploader {
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: calc(100vh - 240px);
	border: 2px dashed #ccc;
	position: relative;
	transition: background-color 0.3s;
}
.component.uploader .file-input {
	display: none;
}
.component.uploader .upload-icon {
	font-size: 1.1rem;
	cursor: pointer;
}
.component.uploader .progress-circle {
	/* Add your circular progress indicator styles here */
}
.component.uploader .dragging {
	background-color: #f0f0f0; 
}
</style>
